import React, { useState, useEffect } from "react";
import { useData } from "../../../context/DataContext";
import { toast } from "react-hot-toast";
import Swal from "sweetalert2";
import ImageUploadField from "../../../utils/ImageUploadField";

const AboutAdmin = () => {
  const { aboutConfig, updateAboutConfig, uploadAboutImage } = useData();

  const [localConfig, setLocalConfig] = useState({
    heading: "",
    description: "",
    buttonText: "",
    buttonLink: "",
    imageUrl: "",
  });
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    setLocalConfig(aboutConfig);
  }, [aboutConfig]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalConfig((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImageFile(file);
    const previewUrl = URL.createObjectURL(file);
    setLocalConfig((cfg) => ({ ...cfg, imageUrl: previewUrl }));
  };

  const handleSave = async () => {
    const result = await Swal.fire({
      title: "Save About Changes?",
      text: "Are you sure you want to update the About section?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, save changes",
    });

    if (!result.isConfirmed) return;
    try {
      await updateAboutConfig({
        heading: localConfig.heading,
        description: localConfig.description,
        buttonText: localConfig.buttonText,
        buttonLink: localConfig.buttonLink,
      });
      if (imageFile) {
        await uploadAboutImage(imageFile);
      }
      toast.success("About section updated successfully.");
    } catch (err) {
      console.error(err);
      toast.error("Error saving About section.");
    }
  };

  return (
    <div className="p- space-y-8">
      <h2 className="text-3xl font-bold mb-4 text-gray-800">About Section Admin Panel</h2>

      {/* Content Inputs */}
      <section className="bg-white p-6 rounded-lg shadow space-y-6">
        <input
          name="heading"
          value={localConfig.heading}
          onChange={handleChange}
          placeholder="Heading"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <textarea
          name="description"
          value={localConfig.description}
          onChange={handleChange}
          placeholder="Description"
          rows={5}
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <input
          name="buttonText"
          value={localConfig.buttonText}
          onChange={handleChange}
          placeholder="Button Text"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
        <input
          name="buttonLink"
          value={localConfig.buttonLink}
          onChange={handleChange}
          placeholder="Button Link (e.g., /about)"
          className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-400"
        />
      </section>

      {/* Image Upload */}
      <section className="bg-white p-6 rounded-lg shadow space-y-4">
        <h3 className="text-2xl font-semibold text-gray-700 mb-2">
          About Image
        </h3>
        <ImageUploadField
          label=""
          hint="Recommended size: 800×600px"
          previewUrl={localConfig.imageUrl}
          file={imageFile}
          onChange={handleFileChange}
        />
      </section>

      {/* Save Button */}
      <div className="flex justify-end">
        <button
          onClick={handleSave}
          className="px-6 py-3 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
};

export default AboutAdmin;
